import { useEffect, useRef } from "react";
import { LogoutTask, registerLogoutTask } from "@/utils/logout-tasks";

/**
 * Registers a flush task that `useAuth().logout` awaits before tearing the
 * session down. The task is held in a ref so the latest closure (formik, refs)
 * runs without re-registering on every render.
 */
export const useLogoutTask = (task: LogoutTask) => {
  const taskRef = useRef(task);
  taskRef.current = task;

  useEffect(
    () => registerLogoutTask((context) => taskRef.current(context)),
    []
  );
};
